<section id="pageCover" class="row">
    <img src="../../../assets/images/contactCover.png" alt="" class="pageCover">
    <!--<div class="row pageTitle">Projects</div>-->
    <div class="row pageBreadcrumbs">
        <!--<ol class="breadcrumb">
            <li><a href="index.html">home</a></li>
            <li class="active">Projects</li>
        </ol>-->
    </div>
</section>

<section id="aboutus" class="row">
    <div class="container">
        <div class="row">
            <div class="col-sm-9">
                <div class="row aboutContent">
                    <div class="row aboutUsTexts m0 member" style="border-bottom: none;">
                        <div class="fleft textsPart">
                            <h3 class="ProjectTitle">{{'Planning' | translate}}</h3>
                            <p id="p1">
                                {{'PlanningDes' | translate}}                            <br /><br />
                            <p id="p2">
                            </p>
                        </div>
                        <div class="fleft aboutImg ">
                            <img src="../../../../assets/images/Services/Service8.png" id="MainImge" alt="MainImge">
                        </div>
                    </div>
                    <!--<div class="row m0 members">
                        <div class="col-sm-4 member3_1 member">
                            <div class="row m0">
                                <div class="row m0 memImg">
                                    <img src="images/team/mem1.png" alt="">
                                </div>
                                <div class="row m0 memberIntro">
                                    <div class="row m0 name">John Smith</div>
                                    <div class="row m0 pro">Chief Executive Officer</div>
                                    <div class="row m0">
                                        <ul class="list-inline memberSocial">
                                            <li><a href="#"><i class="fa fa-google-plus"></i></a></li>
                                            <li><a href="https://twitter.com/MiskConsulting"><i class="fa fa-twitter"></i></a></li>
                                            <li><a href="https://www.linkedin.com/in/MiskConsulting"><i class="fa fa-linkedin"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4 member3_1 member">
                            <div class="row m0">
                                <div class="row m0 memImg">
                                    <img src="images/team/mem2.png" alt="">
                                </div>
                                <div class="row m0 memberIntro">
                                    <div class="row m0 name">Ardian Bold</div>
                                    <div class="row m0 pro">Architect</div>
                                    <div class="row m0">
                                        <ul class="list-inline memberSocial">
                                            <li><a href="#"><i class="fa fa-google-plus"></i></a></li>
                                            <li><a href="https://twitter.com/MiskConsulting"><i class="fa fa-twitter"></i></a></li>
                                            <li><a href="https://www.linkedin.com/in/MiskConsulting"><i class="fa fa-linkedin"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4 member3_1 member">
                            <div class="row m0">
                                <div class="row m0 memImg">
                                    <img src="images/team/mem3.png" alt="">
                                </div>
                                <div class="row m0 memberIntro">
                                    <div class="row m0 name">William Mayer</div>
                                    <div class="row m0 pro">Finance Manager</div>
                                    <div class="row m0">
                                        <ul class="list-inline memberSocial">
                                            <li><a href="#"><i class="fa fa-google-plus"></i></a></li>
                                            <li><a href="https://twitter.com/MiskConsulting"><i class="fa fa-twitter"></i></a></li>
                                            <li><a href="https://www.linkedin.com/in/MiskConsulting"><i class="fa fa-linkedin"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>-->
                </div>
                <!--<div class="row partnersSlide">
                    <h2>Project Photo</h2>
                    <div class="owl-carousel partnerSlider" id="ProjectPhotos">


                    </div>
                </div>-->
            </div>
            <aside class="col-sm-3 sidebar">
                <!--<div class="row m0 recentPostWidget widgetS">
                    <h4>Recent Posts</h4>
                    <div class="row m0 recentblogs">
                        <div class="media recentblog">
                            <div class="media-left">
                                <a href="#">
                                    <img class="media-object" src="images/blog/recent1.png" alt="">
                                </a>
                            </div>
                            <div class="media-body">
                                <a href="#"><h5 class="media-heading">This is PhotoShop's version of Lorem Ipsum</h5></a>
                            </div>
                        </div>
                        <div class="media recentblog">
                            <div class="media-left">
                                <a href="#">
                                    <img class="media-object" src="images/blog/recent2.png" alt="">
                                </a>
                            </div>
                            <div class="media-body">
                                <a href="#"><h5 class="media-heading">This is PhotoShop's version of Lorem Ipsum</h5></a>
                            </div>
                        </div>
                        <div class="media recentblog">
                            <div class="media-left">
                                <a href="#">
                                    <img class="media-object" src="images/blog/recent3.png" alt="">
                                </a>
                            </div>
                            <div class="media-body">
                                <a href="#"><h5 class="media-heading">This is PhotoShop's version of Lorem Ipsum</h5></a>
                            </div>
                        </div>
                    </div>
                </div>-->
                <!--<div class="row m0 contactWidget widgetS">
                    <h4>Contact us</h4>
                    <ul class="list-unstyled">
                        <li><i class="fa fa-phone"></i> 966599454045</li>
                        <li><i class="fa fa-envelope"></i> info@misk-co.com</li>
                        <li><i class="fa fa-home"></i> Building No. 4478,Northern Ring Branch Road Hittin, Riyadh</li>
                    </ul>
                </div>-->
                <!--<div class="row m0 textWidget widgetS">
                    <h4>Text Widget</h4>
                    <p>
                        This is Photoshop's version  of Lorem Ipsum. Proin gravida . Aenean sollicitudin, lorem quis bibendum <br><br>auctor, nisi elit consequat ipsum, nec sagittis sem nibh id
                    </p>
                </div>-->
            </aside>
        </div>
    </div>
</section>